function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lan_d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "20.5 419.29 40.95 149.41 81.84 112.61 98.12 0 0 0 0 720 149.78 720 73.66 529.7 20.5 419.29",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1280 0 1112.56 0 1259.5 398.85 1145.12 720 1280 720 1280 0",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.75 186.21 170.43 31.28 223.14 116.7 266.75 186.21",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "693.84 558.32 786.53 678.27 646.59 495.62 693.84 558.32",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.68 398.85 516.64 186.21 481.19 286.78 441.68 398.85",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "790.32 720 425.33 720 410.33 599.21 573.89 599.21 693.84 558.32 786.53 678.27 790.32 720",
    style: {
      fill: "#060606"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "984.82 720 790.32 720 786.53 678.27 971.9 571.95 984.82 720",
    style: {
      fill: "#040404"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "786.53 678.27 790.32 720 790.32 720 786.53 678.27",
    style: {
      fill: "#040404"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1179.08 531.06 1120.04 720 1076.9 720 1097.3 495.62 1179.08 531.06",
    style: {
      fill: "#090909"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.5 398.85 1145.12 720 1120.04 720 1179.08 531.06 1259.5 398.85",
    style: {
      fill: "#101010"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.3 495.62 1076.9 720 984.82 720 971.9 571.95 1097.3 495.62",
    style: {
      fill: "#080808"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.33 720 266.44 720 252.27 680.07 186.79 495.62 410.33 599.21 425.33 720",
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.44 720 236.27 720 252.27 680.07 266.44 720",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.26 680.07 266.44 720 266.44 720 252.26 680.07 252.26 680.07",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.27 680.07 236.27 720 196.84 720 121.36 523.79 132.27 476.54 186.79 495.62 252.27 680.07",
    style: {
      fill: "#0b0b0b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.26 680.07 186.79 495.62 252.26 680.07 252.26 680.07",
    style: {
      fill: "#0b0b0b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.39 720 149.78 720 73.66 529.7 20.5 419.29 74.11 495.62 121.36 523.79 196.39 720",
    style: {
      fill: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.84 720 196.39 720 121.36 523.79 196.84 720",
    style: {
      fill: "#0f0f0f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.15 476.54 457.58 476.54 410.33 599.21 573.89 599.21 693.84 558.32 646.59 495.62 601.15 476.54",
    style: {
      fill: "#0a0a0a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.3 495.62 971.9 571.95 882.85 398.85 855.59 31.28 871.48 0 986.45 0 1097.3 495.62",
    style: {
      fill: "#262626"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.5 398.85 1179.08 531.06 1097.3 495.62 986.45 0 1112.56 0 1259.5 398.85",
    style: {
      fill: "#252525"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "646.59 495.62 607.97 437.01 601.15 476.54 646.59 495.62",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "882.85 398.85 816.51 349.85 670.67 58.09 687.67 0 836.59 0 855.59 31.28 882.85 398.85",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.58 476.54 601.15 476.54 607.97 437.01 516.64 186.21 467.58 377.04 457.58 476.54",
    style: {
      fill: "#151515"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.19 135.78 816.51 349.85 670.67 58.09 526.19 135.78",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.51 349.85 526.19 135.78 516.64 186.21 607.97 437.01 646.59 495.62 786.53 678.27 971.9 571.95 882.85 398.85 816.51 349.85",
    style: {
      fill: "#181818"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.12 116.7 516.64 186.21 526.19 135.78 500.29 85.35 477.12 116.7",
    style: {
      fill: "#1b1b1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.65 392.03 186.79 495.62 410.33 599.21 457.58 476.54 287.65 392.03",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.63 353.93 287.65 392.03 457.58 476.54 441.68 398.85 332.63 353.93",
    style: {
      fill: "#121212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "871.48 0 855.59 31.28 853.72 0 871.48 0",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.81 0 526.19 135.78 500.29 85.35 520.56 0 563.81 0",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.58 476.54 467.58 377.04 516.64 186.21 441.68 398.85 457.58 476.54",
    style: {
      fill: "#141414"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.49 135.78 481.19 286.78 516.64 186.21 477.12 116.7 463.49 135.78",
    style: {
      fill: "#1a1a1a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.19 286.78 463.49 135.78 357.17 244.82 332.63 353.93 441.68 398.85 481.19 286.78",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.27 476.54 186.79 495.62 155.44 428.83 132.27 476.54",
    style: {
      fill: "#0d0d0d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "855.59 31.28 836.59 0 853.72 0 855.59 31.28",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.67 0 670.67 58.09 526.19 135.78 563.81 0 687.67 0",
    style: {
      fill: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.27 367.5 99.56 234.83 45.03 276.63 20.5 419.29 74.11 495.62 121.36 523.79 132.27 476.54 132.27 367.5",
    style: {
      fill: "#131313"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.63 353.93 357.17 244.82 266.75 186.21 223.14 116.7 132.27 367.5 132.27 476.54 155.44 428.83 186.79 495.62 287.65 392.03 332.63 353.93",
    style: {
      fill: "#191919"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.03 276.63 99.56 234.83 132.27 367.5 223.14 116.7 170.43 31.28 65.03 203.97 45.03 276.63",
    style: {
      fill: "#1e1e1e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.03 203.97 170.43 31.28 81.84 112.61 40.95 149.41 20.5 419.29 45.03 276.63 65.03 203.97",
    style: {
      fill: "#1d1d1d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.43 31.28 81.84 112.61 98.12 0 165.64 0 170.43 31.28",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.07 0 170.43 31.28 165.64 0 184.07 0",
    style: {
      fill: "#2e2e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.56 0 500.29 85.35 477.12 116.7 463.49 135.78 357.17 244.82 266.76 186.21 307.22 0 520.56 0",
    style: {
      fill: "#272727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.78 0 266.76 186.21 170.43 31.28 203.04 0 291.78 0",
    style: {
      fill: "#1f1f1f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.22 0 266.76 186.21 291.78 0 307.22 0",
    style: {
      fill: "#232323"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.04 0 170.43 31.28 184.07 0 203.04 0",
    style: {
      fill: "#313131"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanD);
export default __webpack_public_path__ + "static/media/lan_d.91cd9ae4884a3a68faba8733fbbf775b.svg";
export { ForwardRef as ReactComponent };